import React, { useEffect, useState } from 'react';

function FlyingItem({ startPos, endPos, onComplete }) {
  const [position, setPosition] = useState(startPos);

  useEffect(() => {
    if (!startPos || !endPos) return;

    // Start animation
    const duration = 800; // 0.8 seconds
    const startTime = Date.now();

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function (ease-out)
      const easedProgress = 1 - Math.pow(1 - progress, 3);

      // Calculate current position
      const currentX = startPos.x + (endPos.x - startPos.x) * easedProgress;
      const currentY = startPos.y + (endPos.y - startPos.y) * easedProgress;

      setPosition({ x: currentX, y: currentY });

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Animation complete
        if (onComplete) {
          onComplete();
        }
      }
    };

    requestAnimationFrame(animate);
  }, [startPos, endPos, onComplete]);

  if (!position) return null;

  return (
    <div
      className="fixed pointer-events-none z-[200]"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="relative">
        {/* Gift Box */}
        <div className="bg-gradient-to-br from-primary to-primary-dark rounded-lg p-3 shadow-2xl transform rotate-12">
          {/* Bow */}
          <div className="absolute -top-2 left-1/2 transform -translate-x-1/2">
            <div className="w-3 h-3 bg-red-500 rounded-full"></div>
          </div>
          {/* Box */}
          <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L14.38 12 16 10.83 13.92 8H20v6z"/>
          </svg>
        </div>
        {/* Sparkle effect */}
        <div className="absolute -top-1 -right-1 w-2 h-2 bg-yellow-300 rounded-full animate-ping"></div>
        <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-yellow-300 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
      </div>
    </div>
  );
}

export default FlyingItem;

